// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R100TageRouteImport } from './routes/100-tage'
import { Route as R404RouteImport } from './routes/404'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as CockpitRouteImport } from './routes/_cockpit'
import { Route as BuergermeisterwahlProjekteRouteImport } from './routes/buergermeisterwahl-projekte'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as InternRouteImport } from './routes/intern'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as SeitenuebersichtRouteImport } from './routes/seitenuebersicht'
import { Route as UeberUnsRouteImport } from './routes/ueber-uns'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WahlkampfagenturRouteImport } from './routes/wahlkampfagentur'
import { Route as R100TageIndexRouteImport } from './routes/100-tage.index'
import { Route as R100TageWeiterbildungRouteImport } from './routes/100-tage.weiterbildung'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CasesSlugRouteImport } from './routes/cases.$slug'
import { Route as CockpitLoginRouteImport } from './routes/cockpit_.login'
import { Route as CockpitPasswortVergessenRouteImport } from './routes/cockpit_.passwort-vergessen'
import { Route as CockpitResetPasswordRouteImport } from './routes/cockpit_.reset-password'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsAbsagenRouteImport } from './routes/events.absagen'
import { Route as InternMfaRouteImport } from './routes/intern_.mfa'
import { Route as InternResetPasswordRouteImport } from './routes/intern_.reset-password'
import { Route as InternSetupRouteImport } from './routes/intern_.setup'
import { Route as KaufenAbbruchRouteImport } from './routes/kaufen.abbruch'
import { Route as KaufenBestaetigungRouteImport } from './routes/kaufen.bestaetigung'
import { Route as KontaktIndexRouteImport } from './routes/kontakt.index'
import { Route as KontaktDankeRouteImport } from './routes/kontakt.danke'
import { Route as KostenlosBestaetigenRouteImport } from './routes/kostenlos.bestaetigen'
import { Route as MentoringDankeRouteImport } from './routes/mentoring.danke'
import { Route as PolitischKommunizierenGemeindekommunikationRouteImport } from './routes/politisch-kommunizieren.gemeindekommunikation'
import { Route as PolitischKommunizierenKrisenkommunikationRouteImport } from './routes/politisch-kommunizieren.krisenkommunikation'
import { Route as PolitischKommunizierenPolitischeKommunikationRouteImport } from './routes/politisch-kommunizieren.politische-kommunikation'
import { Route as PolitischKommunizierenVerbandskommunikationRouteImport } from './routes/politisch-kommunizieren.verbandskommunikation'
import { Route as TerminDankeRouteImport } from './routes/termin.danke'
import { Route as TerminDankeEmailRouteImport } from './routes/termin.danke-email'
import { Route as ThemenSlugRouteImport } from './routes/themen.$slug'
import { Route as TtpaSlugRouteImport } from './routes/ttpa.$slug'
import { Route as WahlenGewinnenBuergermeisterwahlRouteImport } from './routes/wahlen-gewinnen.buergermeisterwahl'
import { Route as WahlenGewinnenDirektkandidatenRouteImport } from './routes/wahlen-gewinnen.direktkandidaten'
import { Route as WahlenGewinnenParteikampagnenRouteImport } from './routes/wahlen-gewinnen.parteikampagnen'
import { Route as WahlenGewinnenPersonalratswahlRouteImport } from './routes/wahlen-gewinnen.personalratswahl'
import { Route as WahlenGewinnenWahlkampfRouteImport } from './routes/wahlen-gewinnen.wahlkampf'
import { Route as WahlkalenderBundeslandRouteImport } from './routes/wahlkalender.$bundesland'
import { Route as WissenDownloadsRouteImport } from './routes/wissen.downloads'
import { Route as WissenKeynotesRouteImport } from './routes/wissen.keynotes'
import { Route as WissenKurseRouteImport } from './routes/wissen.kurse'
import { Route as WissenMentoringsRouteImport } from './routes/wissen.mentorings'
import { Route as R100TageWeiterbildungIndexRouteImport } from './routes/100-tage.weiterbildung.index'
import { Route as R100TageWeiterbildungDankeRouteImport } from './routes/100-tage.weiterbildung.danke'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin.admin.index'
import { Route as AdminAdminAbschnitteVorschauRouteImport } from './routes/_admin.admin.abschnitte-vorschau'
import { Route as AdminAdminAuditLogRouteImport } from './routes/_admin.admin.audit-log'
import { Route as AdminAdminAusstattungRouteImport } from './routes/_admin.admin.ausstattung'
import { Route as AdminAdminBlogRouteImport } from './routes/_admin.admin.blog'
import { Route as AdminAdminCampaignDesignRouteImport } from './routes/_admin.admin.campaign-design'
import { Route as AdminAdminCasesRouteImport } from './routes/_admin.admin.cases'
import { Route as AdminAdminClientLogosRouteImport } from './routes/_admin.admin.client-logos'
import { Route as AdminAdminCockpitTexteRouteImport } from './routes/_admin.admin.cockpit-texte'
import { Route as AdminAdminContactSourcesRouteImport } from './routes/_admin.admin.contact-sources'
import { Route as AdminAdminContactsRouteImport } from './routes/_admin.admin.contacts'
import { Route as AdminAdminContactsImportRouteImport } from './routes/_admin.admin.contacts-import'
import { Route as AdminAdminCredentialsRouteImport } from './routes/_admin.admin.credentials'
import { Route as AdminAdminEmailLogRouteImport } from './routes/_admin.admin.email-log'
import { Route as AdminAdminEventsRouteImport } from './routes/_admin.admin.events'
import { Route as AdminAdminFaqRouteImport } from './routes/_admin.admin.faq'
import { Route as AdminAdminFeatureFlagsRouteImport } from './routes/_admin.admin.feature-flags'
import { Route as AdminAdminFontAuditRouteImport } from './routes/_admin.admin.font-audit'
import { Route as AdminAdminInquiriesRouteImport } from './routes/_admin.admin.inquiries'
import { Route as AdminAdminKeynotesRouteImport } from './routes/_admin.admin.keynotes'
import { Route as AdminAdminKiTexteRouteImport } from './routes/_admin.admin.ki-texte'
import { Route as AdminAdminLandingHundertTageRouteImport } from './routes/_admin.admin.landing-hundert-tage'
import { Route as AdminAdminLoginAuditRouteImport } from './routes/_admin.admin.login-audit'
import { Route as AdminAdminMeineAusstattungRouteImport } from './routes/_admin.admin.meine-ausstattung'
import { Route as AdminAdminMocoSyncRouteImport } from './routes/_admin.admin.moco-sync'
import { Route as AdminAdminModuleChaptersRouteImport } from './routes/_admin.admin.module-chapters'
import { Route as AdminAdminModuleIdeasRouteImport } from './routes/_admin.admin.module-ideas'
import { Route as AdminAdminModuleTasksRouteImport } from './routes/_admin.admin.module-tasks'
import { Route as AdminAdminModuleTtpaRouteImport } from './routes/_admin.admin.module-ttpa'
import { Route as AdminAdminProfileRouteImport } from './routes/_admin.admin.profile'
import { Route as AdminAdminPurchasesRouteImport } from './routes/_admin.admin.purchases'
import { Route as AdminAdminQuestionnaireTemplatesRouteImport } from './routes/_admin.admin.questionnaire-templates'
import { Route as AdminAdminRecipientsRouteImport } from './routes/_admin.admin.recipients'
import { Route as AdminAdminRedirectsRouteImport } from './routes/_admin.admin.redirects'
import { Route as AdminAdminScheduledRunsRouteImport } from './routes/_admin.admin.scheduled-runs'
import { Route as AdminAdminServicesRouteImport } from './routes/_admin.admin.services'
import { Route as AdminAdminSilentFailuresRouteImport } from './routes/_admin.admin.silent-failures'
import { Route as AdminAdminTeamRouteImport } from './routes/_admin.admin.team'
import { Route as AdminAdminTestimonialsRouteImport } from './routes/_admin.admin.testimonials'
import { Route as AdminAdminTrafficRouteImport } from './routes/_admin.admin.traffic'
import { Route as AdminAdminWahlkalenderRouteImport } from './routes/_admin.admin.wahlkalender'
import { Route as CockpitCockpitIndexRouteImport } from './routes/_cockpit.cockpit.index'
import { Route as CockpitCockpitDownloadsRouteImport } from './routes/_cockpit.cockpit.downloads'
import { Route as CockpitCockpitFragebogenRouteImport } from './routes/_cockpit.cockpit.fragebogen'
import { Route as CockpitCockpitHilfeRouteImport } from './routes/_cockpit.cockpit.hilfe'
import { Route as CockpitCockpitHundertTageRouteImport } from './routes/_cockpit.cockpit.hundert-tage'
import { Route as CockpitCockpitKaeufeRouteImport } from './routes/_cockpit.cockpit.kaeufe'
import { Route as CockpitCockpitKurseRouteImport } from './routes/_cockpit.cockpit.kurse'
import { Route as CockpitCockpitMeineAusstattungRouteImport } from './routes/_cockpit.cockpit.meine-ausstattung'
import { Route as CockpitCockpitPasswoerterRouteImport } from './routes/_cockpit.cockpit.passwoerter'
import { Route as CockpitCockpitProfilRouteImport } from './routes/_cockpit.cockpit.profil'
import { Route as CockpitCockpitRechnungenRouteImport } from './routes/_cockpit.cockpit.rechnungen'
import { Route as CockpitCockpitSocialMediaRouteImport } from './routes/_cockpit.cockpit.social-media'
import { Route as CockpitCockpitSupportRouteImport } from './routes/_cockpit.cockpit.support'
import { Route as CockpitCockpitWahlkalenderRouteImport } from './routes/_cockpit.cockpit.wahlkalender'
import { Route as KaufenSlugIndexRouteImport } from './routes/kaufen.$slug.index'
import { Route as KostenlosSlugIndexRouteImport } from './routes/kostenlos.$slug.index'
import { Route as KostenlosSlugStepRouteImport } from './routes/kostenlos.$slug.$step'
import { Route as WissenKurseIndexRouteImport } from './routes/wissen.kurse.index'
import { Route as WissenKurseSlugRouteImport } from './routes/wissen.kurse.$slug'
import { Route as WissenMentoringsIndexRouteImport } from './routes/wissen.mentorings.index'
import { Route as WissenMentoringsSlugRouteImport } from './routes/wissen.mentorings.$slug'
import { Route as AdminAdminAusstattungIndexRouteImport } from './routes/_admin.admin.ausstattung.index'
import { Route as AdminAdminAusstattungUserIdRouteImport } from './routes/_admin.admin.ausstattung.$userId'
import { Route as AdminAdminBroadcastsIndexRouteImport } from './routes/_admin.admin.broadcasts.index'
import { Route as AdminAdminBroadcastsIdRouteImport } from './routes/_admin.admin.broadcasts.$id'
import { Route as AdminAdminClientsIndexRouteImport } from './routes/_admin.admin.clients.index'
import { Route as AdminAdminClientsIdRouteImport } from './routes/_admin.admin.clients.$id'
import { Route as AdminAdminCoursesIndexRouteImport } from './routes/_admin.admin.courses.index'
import { Route as AdminAdminCoursesIdRouteImport } from './routes/_admin.admin.courses.$id'
import { Route as AdminAdminDownloadsIndexRouteImport } from './routes/_admin.admin.downloads.index'
import { Route as AdminAdminDownloadsIdRouteImport } from './routes/_admin.admin.downloads.$id'
import { Route as AdminAdminEmailsIndexRouteImport } from './routes/_admin.admin.emails.index'
import { Route as AdminAdminEmailsKeyRouteImport } from './routes/_admin.admin.emails.$key'
import { Route as AdminAdminEmailsAutomationenRouteImport } from './routes/_admin.admin.emails.automationen'
import { Route as AdminAdminInvoicesIndexRouteImport } from './routes/_admin.admin.invoices.index'
import { Route as AdminAdminInvoicesIdRouteImport } from './routes/_admin.admin.invoices.$id'
import { Route as AdminAdminInvoicesSyncLogRouteImport } from './routes/_admin.admin.invoices.sync-log'
import { Route as AdminAdminLeadMagnetsIndexRouteImport } from './routes/_admin.admin.lead-magnets.index'
import { Route as AdminAdminLeadMagnetsIdRouteImport } from './routes/_admin.admin.lead-magnets.$id'
import { Route as AdminAdminMentoringsIndexRouteImport } from './routes/_admin.admin.mentorings.index'
import { Route as AdminAdminMentoringsIdRouteImport } from './routes/_admin.admin.mentorings.$id'
import { Route as AdminAdminQuestionnairesIndexRouteImport } from './routes/_admin.admin.questionnaires.index'
import { Route as AdminAdminQuestionnairesResponseIdRouteImport } from './routes/_admin.admin.questionnaires.$responseId'
import { Route as AdminAdminQuestionnairesBilderRouteImport } from './routes/_admin.admin.questionnaires.bilder'
import { Route as AdminAdminTtpaIndexRouteImport } from './routes/_admin.admin.ttpa.index'
import { Route as AdminAdminTtpaIdRouteImport } from './routes/_admin.admin.ttpa.$id'
import { Route as AdminAdminTtpaVorlageRouteImport } from './routes/_admin.admin.ttpa.vorlage'
import { Route as AdminAdminWahlkalenderPruefeingangRouteImport } from './routes/_admin.admin.wahlkalender_.pruefeingang'
import { Route as CockpitCockpitFragebogenIndexRouteImport } from './routes/_cockpit.cockpit.fragebogen.index'
import { Route as CockpitCockpitFragebogenSlugRouteImport } from './routes/_cockpit.cockpit.fragebogen.$slug'
import { Route as CockpitCockpitHundertTageIndexRouteImport } from './routes/_cockpit.cockpit.hundert-tage.index'
import { Route as CockpitCockpitHundertTagePhaseRouteImport } from './routes/_cockpit.cockpit.hundert-tage.$phase'
import { Route as CockpitCockpitHundertTageIdeenRouteImport } from './routes/_cockpit.cockpit.hundert-tage.ideen'
import { Route as CockpitCockpitHundertTageTtpaRouteImport } from './routes/_cockpit.cockpit.hundert-tage.ttpa'
import { Route as CockpitCockpitHundertTageVorlagenRouteImport } from './routes/_cockpit.cockpit.hundert-tage.vorlagen'
import { Route as CockpitCockpitKurseIndexRouteImport } from './routes/_cockpit.cockpit.kurse.index'
import { Route as CockpitCockpitKurseSlugRouteImport } from './routes/_cockpit.cockpit.kurse.$slug'
import { Route as CockpitCockpitWahlkalenderAenderungMeldenRouteImport } from './routes/_cockpit.cockpit.wahlkalender_.aenderung-melden'
import { Route as CockpitCockpitWahlkalenderBeobachtetRouteImport } from './routes/_cockpit.cockpit.wahlkalender_.beobachtet'
import { Route as AdminAdminKiTexteVorschauIdRouteImport } from './routes/_admin.admin.ki-texte_.vorschau.$id'
import { Route as AdminAdminWahlkalenderVorschauBundeslandRouteImport } from './routes/_admin.admin.wahlkalender_.vorschau.$bundesland'
import { Route as CockpitCockpitHundertTageAnfrageKeyRouteImport } from './routes/_cockpit.cockpit.hundert-tage.anfrage.$key'
import { Route as CockpitCockpitHundertTageKapitelIndexRouteImport } from './routes/_cockpit.cockpit.hundert-tage.kapitel.index'
import { Route as CockpitCockpitHundertTageKapitelSlugRouteImport } from './routes/_cockpit.cockpit.hundert-tage.kapitel.$slug'
import { Route as CockpitCockpitHundertTageVorlagenIndexRouteImport } from './routes/_cockpit.cockpit.hundert-tage.vorlagen.index'
import { Route as CockpitCockpitHundertTageVorlagenKaemmereiRouteImport } from './routes/_cockpit.cockpit.hundert-tage.vorlagen.kaemmerei'
import { Route as CockpitCockpitHundertTageVorlagenKrisenplanRouteImport } from './routes/_cockpit.cockpit.hundert-tage.vorlagen.krisenplan'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R100TageRoute = R100TageRouteImport.update({
            id: '/100-tage',path: '/100-tage',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const CockpitRoute = CockpitRouteImport.update({
            id: '/_cockpit',getParentRoute: () => rootRouteImport
          })
const BuergermeisterwahlProjekteRoute = BuergermeisterwahlProjekteRouteImport.update({
            id: '/buergermeisterwahl-projekte',path: '/buergermeisterwahl-projekte',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const InternRoute = InternRouteImport.update({
            id: '/intern',path: '/intern',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const SeitenuebersichtRoute = SeitenuebersichtRouteImport.update({
            id: '/seitenuebersicht',path: '/seitenuebersicht',getParentRoute: () => rootRouteImport
          })
const UeberUnsRoute = UeberUnsRouteImport.update({
            id: '/ueber-uns',path: '/ueber-uns',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WahlkampfagenturRoute = WahlkampfagenturRouteImport.update({
            id: '/wahlkampfagentur',path: '/wahlkampfagentur',getParentRoute: () => rootRouteImport
          })
const R100TageIndexRoute = R100TageIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => R100TageRoute
          })
const R100TageWeiterbildungRoute = R100TageWeiterbildungRouteImport.update({
            id: '/weiterbildung',path: '/weiterbildung',getParentRoute: () => R100TageRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CasesSlugRoute = CasesSlugRouteImport.update({
            id: '/cases/$slug',path: '/cases/$slug',getParentRoute: () => rootRouteImport
          })
const CockpitLoginRoute = CockpitLoginRouteImport.update({
            id: '/cockpit_/login',path: '/cockpit/login',getParentRoute: () => rootRouteImport
          })
const CockpitPasswortVergessenRoute = CockpitPasswortVergessenRouteImport.update({
            id: '/cockpit_/passwort-vergessen',path: '/cockpit/passwort-vergessen',getParentRoute: () => rootRouteImport
          })
const CockpitResetPasswordRoute = CockpitResetPasswordRouteImport.update({
            id: '/cockpit_/reset-password',path: '/cockpit/reset-password',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const EventsAbsagenRoute = EventsAbsagenRouteImport.update({
            id: '/events/absagen',path: '/events/absagen',getParentRoute: () => rootRouteImport
          })
const InternMfaRoute = InternMfaRouteImport.update({
            id: '/intern_/mfa',path: '/intern/mfa',getParentRoute: () => rootRouteImport
          })
const InternResetPasswordRoute = InternResetPasswordRouteImport.update({
            id: '/intern_/reset-password',path: '/intern/reset-password',getParentRoute: () => rootRouteImport
          })
const InternSetupRoute = InternSetupRouteImport.update({
            id: '/intern_/setup',path: '/intern/setup',getParentRoute: () => rootRouteImport
          })
const KaufenAbbruchRoute = KaufenAbbruchRouteImport.update({
            id: '/kaufen/abbruch',path: '/kaufen/abbruch',getParentRoute: () => rootRouteImport
          })
const KaufenBestaetigungRoute = KaufenBestaetigungRouteImport.update({
            id: '/kaufen/bestaetigung',path: '/kaufen/bestaetigung',getParentRoute: () => rootRouteImport
          })
const KontaktIndexRoute = KontaktIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KontaktRoute
          })
const KontaktDankeRoute = KontaktDankeRouteImport.update({
            id: '/danke',path: '/danke',getParentRoute: () => KontaktRoute
          })
const KostenlosBestaetigenRoute = KostenlosBestaetigenRouteImport.update({
            id: '/kostenlos/bestaetigen',path: '/kostenlos/bestaetigen',getParentRoute: () => rootRouteImport
          })
const MentoringDankeRoute = MentoringDankeRouteImport.update({
            id: '/mentoring/danke',path: '/mentoring/danke',getParentRoute: () => rootRouteImport
          })
const PolitischKommunizierenGemeindekommunikationRoute = PolitischKommunizierenGemeindekommunikationRouteImport.update({
            id: '/politisch-kommunizieren/gemeindekommunikation',path: '/politisch-kommunizieren/gemeindekommunikation',getParentRoute: () => rootRouteImport
          })
const PolitischKommunizierenKrisenkommunikationRoute = PolitischKommunizierenKrisenkommunikationRouteImport.update({
            id: '/politisch-kommunizieren/krisenkommunikation',path: '/politisch-kommunizieren/krisenkommunikation',getParentRoute: () => rootRouteImport
          })
const PolitischKommunizierenPolitischeKommunikationRoute = PolitischKommunizierenPolitischeKommunikationRouteImport.update({
            id: '/politisch-kommunizieren/politische-kommunikation',path: '/politisch-kommunizieren/politische-kommunikation',getParentRoute: () => rootRouteImport
          })
const PolitischKommunizierenVerbandskommunikationRoute = PolitischKommunizierenVerbandskommunikationRouteImport.update({
            id: '/politisch-kommunizieren/verbandskommunikation',path: '/politisch-kommunizieren/verbandskommunikation',getParentRoute: () => rootRouteImport
          })
const TerminDankeRoute = TerminDankeRouteImport.update({
            id: '/termin/danke',path: '/termin/danke',getParentRoute: () => rootRouteImport
          })
const TerminDankeEmailRoute = TerminDankeEmailRouteImport.update({
            id: '/termin/danke-email',path: '/termin/danke-email',getParentRoute: () => rootRouteImport
          })
const ThemenSlugRoute = ThemenSlugRouteImport.update({
            id: '/themen/$slug',path: '/themen/$slug',getParentRoute: () => rootRouteImport
          })
const TtpaSlugRoute = TtpaSlugRouteImport.update({
            id: '/ttpa/$slug',path: '/ttpa/$slug',getParentRoute: () => rootRouteImport
          })
const WahlenGewinnenBuergermeisterwahlRoute = WahlenGewinnenBuergermeisterwahlRouteImport.update({
            id: '/wahlen-gewinnen/buergermeisterwahl',path: '/wahlen-gewinnen/buergermeisterwahl',getParentRoute: () => rootRouteImport
          })
const WahlenGewinnenDirektkandidatenRoute = WahlenGewinnenDirektkandidatenRouteImport.update({
            id: '/wahlen-gewinnen/direktkandidaten',path: '/wahlen-gewinnen/direktkandidaten',getParentRoute: () => rootRouteImport
          })
const WahlenGewinnenParteikampagnenRoute = WahlenGewinnenParteikampagnenRouteImport.update({
            id: '/wahlen-gewinnen/parteikampagnen',path: '/wahlen-gewinnen/parteikampagnen',getParentRoute: () => rootRouteImport
          })
const WahlenGewinnenPersonalratswahlRoute = WahlenGewinnenPersonalratswahlRouteImport.update({
            id: '/wahlen-gewinnen/personalratswahl',path: '/wahlen-gewinnen/personalratswahl',getParentRoute: () => rootRouteImport
          })
const WahlenGewinnenWahlkampfRoute = WahlenGewinnenWahlkampfRouteImport.update({
            id: '/wahlen-gewinnen/wahlkampf',path: '/wahlen-gewinnen/wahlkampf',getParentRoute: () => rootRouteImport
          })
const WahlkalenderBundeslandRoute = WahlkalenderBundeslandRouteImport.update({
            id: '/wahlkalender/$bundesland',path: '/wahlkalender/$bundesland',getParentRoute: () => rootRouteImport
          })
const WissenDownloadsRoute = WissenDownloadsRouteImport.update({
            id: '/wissen/downloads',path: '/wissen/downloads',getParentRoute: () => rootRouteImport
          })
const WissenKeynotesRoute = WissenKeynotesRouteImport.update({
            id: '/wissen/keynotes',path: '/wissen/keynotes',getParentRoute: () => rootRouteImport
          })
const WissenKurseRoute = WissenKurseRouteImport.update({
            id: '/wissen/kurse',path: '/wissen/kurse',getParentRoute: () => rootRouteImport
          })
const WissenMentoringsRoute = WissenMentoringsRouteImport.update({
            id: '/wissen/mentorings',path: '/wissen/mentorings',getParentRoute: () => rootRouteImport
          })
const R100TageWeiterbildungIndexRoute = R100TageWeiterbildungIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => R100TageWeiterbildungRoute
          })
const R100TageWeiterbildungDankeRoute = R100TageWeiterbildungDankeRouteImport.update({
            id: '/danke',path: '/danke',getParentRoute: () => R100TageWeiterbildungRoute
          })
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AdminRoute
          })
const AdminAdminAbschnitteVorschauRoute = AdminAdminAbschnitteVorschauRouteImport.update({
            id: '/admin/abschnitte-vorschau',path: '/admin/abschnitte-vorschau',getParentRoute: () => AdminRoute
          })
const AdminAdminAuditLogRoute = AdminAdminAuditLogRouteImport.update({
            id: '/admin/audit-log',path: '/admin/audit-log',getParentRoute: () => AdminRoute
          })
const AdminAdminAusstattungRoute = AdminAdminAusstattungRouteImport.update({
            id: '/admin/ausstattung',path: '/admin/ausstattung',getParentRoute: () => AdminRoute
          })
const AdminAdminBlogRoute = AdminAdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => AdminRoute
          })
const AdminAdminCampaignDesignRoute = AdminAdminCampaignDesignRouteImport.update({
            id: '/admin/campaign-design',path: '/admin/campaign-design',getParentRoute: () => AdminRoute
          })
const AdminAdminCasesRoute = AdminAdminCasesRouteImport.update({
            id: '/admin/cases',path: '/admin/cases',getParentRoute: () => AdminRoute
          })
const AdminAdminClientLogosRoute = AdminAdminClientLogosRouteImport.update({
            id: '/admin/client-logos',path: '/admin/client-logos',getParentRoute: () => AdminRoute
          })
const AdminAdminCockpitTexteRoute = AdminAdminCockpitTexteRouteImport.update({
            id: '/admin/cockpit-texte',path: '/admin/cockpit-texte',getParentRoute: () => AdminRoute
          })
const AdminAdminContactSourcesRoute = AdminAdminContactSourcesRouteImport.update({
            id: '/admin/contact-sources',path: '/admin/contact-sources',getParentRoute: () => AdminRoute
          })
const AdminAdminContactsRoute = AdminAdminContactsRouteImport.update({
            id: '/admin/contacts',path: '/admin/contacts',getParentRoute: () => AdminRoute
          })
const AdminAdminContactsImportRoute = AdminAdminContactsImportRouteImport.update({
            id: '/admin/contacts-import',path: '/admin/contacts-import',getParentRoute: () => AdminRoute
          })
const AdminAdminCredentialsRoute = AdminAdminCredentialsRouteImport.update({
            id: '/admin/credentials',path: '/admin/credentials',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailLogRoute = AdminAdminEmailLogRouteImport.update({
            id: '/admin/email-log',path: '/admin/email-log',getParentRoute: () => AdminRoute
          })
const AdminAdminEventsRoute = AdminAdminEventsRouteImport.update({
            id: '/admin/events',path: '/admin/events',getParentRoute: () => AdminRoute
          })
const AdminAdminFaqRoute = AdminAdminFaqRouteImport.update({
            id: '/admin/faq',path: '/admin/faq',getParentRoute: () => AdminRoute
          })
const AdminAdminFeatureFlagsRoute = AdminAdminFeatureFlagsRouteImport.update({
            id: '/admin/feature-flags',path: '/admin/feature-flags',getParentRoute: () => AdminRoute
          })
const AdminAdminFontAuditRoute = AdminAdminFontAuditRouteImport.update({
            id: '/admin/font-audit',path: '/admin/font-audit',getParentRoute: () => AdminRoute
          })
const AdminAdminInquiriesRoute = AdminAdminInquiriesRouteImport.update({
            id: '/admin/inquiries',path: '/admin/inquiries',getParentRoute: () => AdminRoute
          })
const AdminAdminKeynotesRoute = AdminAdminKeynotesRouteImport.update({
            id: '/admin/keynotes',path: '/admin/keynotes',getParentRoute: () => AdminRoute
          })
const AdminAdminKiTexteRoute = AdminAdminKiTexteRouteImport.update({
            id: '/admin/ki-texte',path: '/admin/ki-texte',getParentRoute: () => AdminRoute
          })
const AdminAdminLandingHundertTageRoute = AdminAdminLandingHundertTageRouteImport.update({
            id: '/admin/landing-hundert-tage',path: '/admin/landing-hundert-tage',getParentRoute: () => AdminRoute
          })
const AdminAdminLoginAuditRoute = AdminAdminLoginAuditRouteImport.update({
            id: '/admin/login-audit',path: '/admin/login-audit',getParentRoute: () => AdminRoute
          })
const AdminAdminMeineAusstattungRoute = AdminAdminMeineAusstattungRouteImport.update({
            id: '/admin/meine-ausstattung',path: '/admin/meine-ausstattung',getParentRoute: () => AdminRoute
          })
const AdminAdminMocoSyncRoute = AdminAdminMocoSyncRouteImport.update({
            id: '/admin/moco-sync',path: '/admin/moco-sync',getParentRoute: () => AdminRoute
          })
const AdminAdminModuleChaptersRoute = AdminAdminModuleChaptersRouteImport.update({
            id: '/admin/module-chapters',path: '/admin/module-chapters',getParentRoute: () => AdminRoute
          })
const AdminAdminModuleIdeasRoute = AdminAdminModuleIdeasRouteImport.update({
            id: '/admin/module-ideas',path: '/admin/module-ideas',getParentRoute: () => AdminRoute
          })
const AdminAdminModuleTasksRoute = AdminAdminModuleTasksRouteImport.update({
            id: '/admin/module-tasks',path: '/admin/module-tasks',getParentRoute: () => AdminRoute
          })
const AdminAdminModuleTtpaRoute = AdminAdminModuleTtpaRouteImport.update({
            id: '/admin/module-ttpa',path: '/admin/module-ttpa',getParentRoute: () => AdminRoute
          })
const AdminAdminProfileRoute = AdminAdminProfileRouteImport.update({
            id: '/admin/profile',path: '/admin/profile',getParentRoute: () => AdminRoute
          })
const AdminAdminPurchasesRoute = AdminAdminPurchasesRouteImport.update({
            id: '/admin/purchases',path: '/admin/purchases',getParentRoute: () => AdminRoute
          })
const AdminAdminQuestionnaireTemplatesRoute = AdminAdminQuestionnaireTemplatesRouteImport.update({
            id: '/admin/questionnaire-templates',path: '/admin/questionnaire-templates',getParentRoute: () => AdminRoute
          })
const AdminAdminRecipientsRoute = AdminAdminRecipientsRouteImport.update({
            id: '/admin/recipients',path: '/admin/recipients',getParentRoute: () => AdminRoute
          })
const AdminAdminRedirectsRoute = AdminAdminRedirectsRouteImport.update({
            id: '/admin/redirects',path: '/admin/redirects',getParentRoute: () => AdminRoute
          })
const AdminAdminScheduledRunsRoute = AdminAdminScheduledRunsRouteImport.update({
            id: '/admin/scheduled-runs',path: '/admin/scheduled-runs',getParentRoute: () => AdminRoute
          })
const AdminAdminServicesRoute = AdminAdminServicesRouteImport.update({
            id: '/admin/services',path: '/admin/services',getParentRoute: () => AdminRoute
          })
const AdminAdminSilentFailuresRoute = AdminAdminSilentFailuresRouteImport.update({
            id: '/admin/silent-failures',path: '/admin/silent-failures',getParentRoute: () => AdminRoute
          })
const AdminAdminTeamRoute = AdminAdminTeamRouteImport.update({
            id: '/admin/team',path: '/admin/team',getParentRoute: () => AdminRoute
          })
const AdminAdminTestimonialsRoute = AdminAdminTestimonialsRouteImport.update({
            id: '/admin/testimonials',path: '/admin/testimonials',getParentRoute: () => AdminRoute
          })
const AdminAdminTrafficRoute = AdminAdminTrafficRouteImport.update({
            id: '/admin/traffic',path: '/admin/traffic',getParentRoute: () => AdminRoute
          })
const AdminAdminWahlkalenderRoute = AdminAdminWahlkalenderRouteImport.update({
            id: '/admin/wahlkalender',path: '/admin/wahlkalender',getParentRoute: () => AdminRoute
          })
const CockpitCockpitIndexRoute = CockpitCockpitIndexRouteImport.update({
            id: '/cockpit/',path: '/cockpit/',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitDownloadsRoute = CockpitCockpitDownloadsRouteImport.update({
            id: '/cockpit/downloads',path: '/cockpit/downloads',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitFragebogenRoute = CockpitCockpitFragebogenRouteImport.update({
            id: '/cockpit/fragebogen',path: '/cockpit/fragebogen',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitHilfeRoute = CockpitCockpitHilfeRouteImport.update({
            id: '/cockpit/hilfe',path: '/cockpit/hilfe',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitHundertTageRoute = CockpitCockpitHundertTageRouteImport.update({
            id: '/cockpit/hundert-tage',path: '/cockpit/hundert-tage',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitKaeufeRoute = CockpitCockpitKaeufeRouteImport.update({
            id: '/cockpit/kaeufe',path: '/cockpit/kaeufe',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitKurseRoute = CockpitCockpitKurseRouteImport.update({
            id: '/cockpit/kurse',path: '/cockpit/kurse',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitMeineAusstattungRoute = CockpitCockpitMeineAusstattungRouteImport.update({
            id: '/cockpit/meine-ausstattung',path: '/cockpit/meine-ausstattung',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitPasswoerterRoute = CockpitCockpitPasswoerterRouteImport.update({
            id: '/cockpit/passwoerter',path: '/cockpit/passwoerter',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitProfilRoute = CockpitCockpitProfilRouteImport.update({
            id: '/cockpit/profil',path: '/cockpit/profil',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitRechnungenRoute = CockpitCockpitRechnungenRouteImport.update({
            id: '/cockpit/rechnungen',path: '/cockpit/rechnungen',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitSocialMediaRoute = CockpitCockpitSocialMediaRouteImport.update({
            id: '/cockpit/social-media',path: '/cockpit/social-media',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitSupportRoute = CockpitCockpitSupportRouteImport.update({
            id: '/cockpit/support',path: '/cockpit/support',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitWahlkalenderRoute = CockpitCockpitWahlkalenderRouteImport.update({
            id: '/cockpit/wahlkalender',path: '/cockpit/wahlkalender',getParentRoute: () => CockpitRoute
          })
const KaufenSlugIndexRoute = KaufenSlugIndexRouteImport.update({
            id: '/kaufen/$slug/',path: '/kaufen/$slug/',getParentRoute: () => rootRouteImport
          })
const KostenlosSlugIndexRoute = KostenlosSlugIndexRouteImport.update({
            id: '/kostenlos/$slug/',path: '/kostenlos/$slug/',getParentRoute: () => rootRouteImport
          })
const KostenlosSlugStepRoute = KostenlosSlugStepRouteImport.update({
            id: '/kostenlos/$slug/$step',path: '/kostenlos/$slug/$step',getParentRoute: () => rootRouteImport
          })
const WissenKurseIndexRoute = WissenKurseIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WissenKurseRoute
          })
const WissenKurseSlugRoute = WissenKurseSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => WissenKurseRoute
          })
const WissenMentoringsIndexRoute = WissenMentoringsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WissenMentoringsRoute
          })
const WissenMentoringsSlugRoute = WissenMentoringsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => WissenMentoringsRoute
          })
const AdminAdminAusstattungIndexRoute = AdminAdminAusstattungIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminAdminAusstattungRoute
          })
const AdminAdminAusstattungUserIdRoute = AdminAdminAusstattungUserIdRouteImport.update({
            id: '/$userId',path: '/$userId',getParentRoute: () => AdminAdminAusstattungRoute
          })
const AdminAdminBroadcastsIndexRoute = AdminAdminBroadcastsIndexRouteImport.update({
            id: '/admin/broadcasts/',path: '/admin/broadcasts/',getParentRoute: () => AdminRoute
          })
const AdminAdminBroadcastsIdRoute = AdminAdminBroadcastsIdRouteImport.update({
            id: '/admin/broadcasts/$id',path: '/admin/broadcasts/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminClientsIndexRoute = AdminAdminClientsIndexRouteImport.update({
            id: '/admin/clients/',path: '/admin/clients/',getParentRoute: () => AdminRoute
          })
const AdminAdminClientsIdRoute = AdminAdminClientsIdRouteImport.update({
            id: '/admin/clients/$id',path: '/admin/clients/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminCoursesIndexRoute = AdminAdminCoursesIndexRouteImport.update({
            id: '/admin/courses/',path: '/admin/courses/',getParentRoute: () => AdminRoute
          })
const AdminAdminCoursesIdRoute = AdminAdminCoursesIdRouteImport.update({
            id: '/admin/courses/$id',path: '/admin/courses/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminDownloadsIndexRoute = AdminAdminDownloadsIndexRouteImport.update({
            id: '/admin/downloads/',path: '/admin/downloads/',getParentRoute: () => AdminRoute
          })
const AdminAdminDownloadsIdRoute = AdminAdminDownloadsIdRouteImport.update({
            id: '/admin/downloads/$id',path: '/admin/downloads/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailsIndexRoute = AdminAdminEmailsIndexRouteImport.update({
            id: '/admin/emails/',path: '/admin/emails/',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailsKeyRoute = AdminAdminEmailsKeyRouteImport.update({
            id: '/admin/emails/$key',path: '/admin/emails/$key',getParentRoute: () => AdminRoute
          })
const AdminAdminEmailsAutomationenRoute = AdminAdminEmailsAutomationenRouteImport.update({
            id: '/admin/emails/automationen',path: '/admin/emails/automationen',getParentRoute: () => AdminRoute
          })
const AdminAdminInvoicesIndexRoute = AdminAdminInvoicesIndexRouteImport.update({
            id: '/admin/invoices/',path: '/admin/invoices/',getParentRoute: () => AdminRoute
          })
const AdminAdminInvoicesIdRoute = AdminAdminInvoicesIdRouteImport.update({
            id: '/admin/invoices/$id',path: '/admin/invoices/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminInvoicesSyncLogRoute = AdminAdminInvoicesSyncLogRouteImport.update({
            id: '/admin/invoices/sync-log',path: '/admin/invoices/sync-log',getParentRoute: () => AdminRoute
          })
const AdminAdminLeadMagnetsIndexRoute = AdminAdminLeadMagnetsIndexRouteImport.update({
            id: '/admin/lead-magnets/',path: '/admin/lead-magnets/',getParentRoute: () => AdminRoute
          })
const AdminAdminLeadMagnetsIdRoute = AdminAdminLeadMagnetsIdRouteImport.update({
            id: '/admin/lead-magnets/$id',path: '/admin/lead-magnets/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminMentoringsIndexRoute = AdminAdminMentoringsIndexRouteImport.update({
            id: '/admin/mentorings/',path: '/admin/mentorings/',getParentRoute: () => AdminRoute
          })
const AdminAdminMentoringsIdRoute = AdminAdminMentoringsIdRouteImport.update({
            id: '/admin/mentorings/$id',path: '/admin/mentorings/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminQuestionnairesIndexRoute = AdminAdminQuestionnairesIndexRouteImport.update({
            id: '/admin/questionnaires/',path: '/admin/questionnaires/',getParentRoute: () => AdminRoute
          })
const AdminAdminQuestionnairesResponseIdRoute = AdminAdminQuestionnairesResponseIdRouteImport.update({
            id: '/admin/questionnaires/$responseId',path: '/admin/questionnaires/$responseId',getParentRoute: () => AdminRoute
          })
const AdminAdminQuestionnairesBilderRoute = AdminAdminQuestionnairesBilderRouteImport.update({
            id: '/admin/questionnaires/bilder',path: '/admin/questionnaires/bilder',getParentRoute: () => AdminRoute
          })
const AdminAdminTtpaIndexRoute = AdminAdminTtpaIndexRouteImport.update({
            id: '/admin/ttpa/',path: '/admin/ttpa/',getParentRoute: () => AdminRoute
          })
const AdminAdminTtpaIdRoute = AdminAdminTtpaIdRouteImport.update({
            id: '/admin/ttpa/$id',path: '/admin/ttpa/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminTtpaVorlageRoute = AdminAdminTtpaVorlageRouteImport.update({
            id: '/admin/ttpa/vorlage',path: '/admin/ttpa/vorlage',getParentRoute: () => AdminRoute
          })
const AdminAdminWahlkalenderPruefeingangRoute = AdminAdminWahlkalenderPruefeingangRouteImport.update({
            id: '/admin/wahlkalender_/pruefeingang',path: '/admin/wahlkalender/pruefeingang',getParentRoute: () => AdminRoute
          })
const CockpitCockpitFragebogenIndexRoute = CockpitCockpitFragebogenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CockpitCockpitFragebogenRoute
          })
const CockpitCockpitFragebogenSlugRoute = CockpitCockpitFragebogenSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CockpitCockpitFragebogenRoute
          })
const CockpitCockpitHundertTageIndexRoute = CockpitCockpitHundertTageIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTagePhaseRoute = CockpitCockpitHundertTagePhaseRouteImport.update({
            id: '/$phase',path: '/$phase',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTageIdeenRoute = CockpitCockpitHundertTageIdeenRouteImport.update({
            id: '/ideen',path: '/ideen',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTageTtpaRoute = CockpitCockpitHundertTageTtpaRouteImport.update({
            id: '/ttpa',path: '/ttpa',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTageVorlagenRoute = CockpitCockpitHundertTageVorlagenRouteImport.update({
            id: '/vorlagen',path: '/vorlagen',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitKurseIndexRoute = CockpitCockpitKurseIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CockpitCockpitKurseRoute
          })
const CockpitCockpitKurseSlugRoute = CockpitCockpitKurseSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CockpitCockpitKurseRoute
          })
const CockpitCockpitWahlkalenderAenderungMeldenRoute = CockpitCockpitWahlkalenderAenderungMeldenRouteImport.update({
            id: '/cockpit/wahlkalender_/aenderung-melden',path: '/cockpit/wahlkalender/aenderung-melden',getParentRoute: () => CockpitRoute
          })
const CockpitCockpitWahlkalenderBeobachtetRoute = CockpitCockpitWahlkalenderBeobachtetRouteImport.update({
            id: '/cockpit/wahlkalender_/beobachtet',path: '/cockpit/wahlkalender/beobachtet',getParentRoute: () => CockpitRoute
          })
const AdminAdminKiTexteVorschauIdRoute = AdminAdminKiTexteVorschauIdRouteImport.update({
            id: '/admin/ki-texte_/vorschau/$id',path: '/admin/ki-texte/vorschau/$id',getParentRoute: () => AdminRoute
          })
const AdminAdminWahlkalenderVorschauBundeslandRoute = AdminAdminWahlkalenderVorschauBundeslandRouteImport.update({
            id: '/admin/wahlkalender_/vorschau/$bundesland',path: '/admin/wahlkalender/vorschau/$bundesland',getParentRoute: () => AdminRoute
          })
const CockpitCockpitHundertTageAnfrageKeyRoute = CockpitCockpitHundertTageAnfrageKeyRouteImport.update({
            id: '/anfrage/$key',path: '/anfrage/$key',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTageKapitelIndexRoute = CockpitCockpitHundertTageKapitelIndexRouteImport.update({
            id: '/kapitel/',path: '/kapitel/',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTageKapitelSlugRoute = CockpitCockpitHundertTageKapitelSlugRouteImport.update({
            id: '/kapitel/$slug',path: '/kapitel/$slug',getParentRoute: () => CockpitCockpitHundertTageRoute
          })
const CockpitCockpitHundertTageVorlagenIndexRoute = CockpitCockpitHundertTageVorlagenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CockpitCockpitHundertTageVorlagenRoute
          })
const CockpitCockpitHundertTageVorlagenKaemmereiRoute = CockpitCockpitHundertTageVorlagenKaemmereiRouteImport.update({
            id: '/kaemmerei',path: '/kaemmerei',getParentRoute: () => CockpitCockpitHundertTageVorlagenRoute
          })
const CockpitCockpitHundertTageVorlagenKrisenplanRoute = CockpitCockpitHundertTageVorlagenKrisenplanRouteImport.update({
            id: '/krisenplan',path: '/krisenplan',getParentRoute: () => CockpitCockpitHundertTageVorlagenRoute
          })





const R100TageWeiterbildungRouteChildren = {
  R100TageWeiterbildungDankeRoute: R100TageWeiterbildungDankeRoute,R100TageWeiterbildungIndexRoute: R100TageWeiterbildungIndexRoute
}

const R100TageWeiterbildungRouteWithChildren = R100TageWeiterbildungRoute._addFileChildren(R100TageWeiterbildungRouteChildren)



const R100TageRouteChildren = {
  R100TageWeiterbildungRoute: R100TageWeiterbildungRouteWithChildren,R100TageIndexRoute: R100TageIndexRoute
}

const R100TageRouteWithChildren = R100TageRoute._addFileChildren(R100TageRouteChildren)




const AdminAdminAusstattungRouteChildren = {
  AdminAdminAusstattungUserIdRoute: AdminAdminAusstattungUserIdRoute,AdminAdminAusstattungIndexRoute: AdminAdminAusstattungIndexRoute
}

const AdminAdminAusstattungRouteWithChildren = AdminAdminAusstattungRoute._addFileChildren(AdminAdminAusstattungRouteChildren)



const AdminRouteChildren = {
  AdminAdminAbschnitteVorschauRoute: AdminAdminAbschnitteVorschauRoute,AdminAdminAuditLogRoute: AdminAdminAuditLogRoute,AdminAdminAusstattungRoute: AdminAdminAusstattungRouteWithChildren,AdminAdminBlogRoute: AdminAdminBlogRoute,AdminAdminCampaignDesignRoute: AdminAdminCampaignDesignRoute,AdminAdminCasesRoute: AdminAdminCasesRoute,AdminAdminClientLogosRoute: AdminAdminClientLogosRoute,AdminAdminCockpitTexteRoute: AdminAdminCockpitTexteRoute,AdminAdminContactSourcesRoute: AdminAdminContactSourcesRoute,AdminAdminContactsRoute: AdminAdminContactsRoute,AdminAdminContactsImportRoute: AdminAdminContactsImportRoute,AdminAdminCredentialsRoute: AdminAdminCredentialsRoute,AdminAdminEmailLogRoute: AdminAdminEmailLogRoute,AdminAdminEventsRoute: AdminAdminEventsRoute,AdminAdminFaqRoute: AdminAdminFaqRoute,AdminAdminFeatureFlagsRoute: AdminAdminFeatureFlagsRoute,AdminAdminFontAuditRoute: AdminAdminFontAuditRoute,AdminAdminInquiriesRoute: AdminAdminInquiriesRoute,AdminAdminKeynotesRoute: AdminAdminKeynotesRoute,AdminAdminKiTexteRoute: AdminAdminKiTexteRoute,AdminAdminLandingHundertTageRoute: AdminAdminLandingHundertTageRoute,AdminAdminLoginAuditRoute: AdminAdminLoginAuditRoute,AdminAdminMeineAusstattungRoute: AdminAdminMeineAusstattungRoute,AdminAdminMocoSyncRoute: AdminAdminMocoSyncRoute,AdminAdminModuleChaptersRoute: AdminAdminModuleChaptersRoute,AdminAdminModuleIdeasRoute: AdminAdminModuleIdeasRoute,AdminAdminModuleTasksRoute: AdminAdminModuleTasksRoute,AdminAdminModuleTtpaRoute: AdminAdminModuleTtpaRoute,AdminAdminProfileRoute: AdminAdminProfileRoute,AdminAdminPurchasesRoute: AdminAdminPurchasesRoute,AdminAdminQuestionnaireTemplatesRoute: AdminAdminQuestionnaireTemplatesRoute,AdminAdminRecipientsRoute: AdminAdminRecipientsRoute,AdminAdminRedirectsRoute: AdminAdminRedirectsRoute,AdminAdminScheduledRunsRoute: AdminAdminScheduledRunsRoute,AdminAdminServicesRoute: AdminAdminServicesRoute,AdminAdminSilentFailuresRoute: AdminAdminSilentFailuresRoute,AdminAdminTeamRoute: AdminAdminTeamRoute,AdminAdminTestimonialsRoute: AdminAdminTestimonialsRoute,AdminAdminTrafficRoute: AdminAdminTrafficRoute,AdminAdminWahlkalenderRoute: AdminAdminWahlkalenderRoute,AdminAdminIndexRoute: AdminAdminIndexRoute,AdminAdminBroadcastsIdRoute: AdminAdminBroadcastsIdRoute,AdminAdminClientsIdRoute: AdminAdminClientsIdRoute,AdminAdminCoursesIdRoute: AdminAdminCoursesIdRoute,AdminAdminDownloadsIdRoute: AdminAdminDownloadsIdRoute,AdminAdminEmailsKeyRoute: AdminAdminEmailsKeyRoute,AdminAdminEmailsAutomationenRoute: AdminAdminEmailsAutomationenRoute,AdminAdminInvoicesIdRoute: AdminAdminInvoicesIdRoute,AdminAdminInvoicesSyncLogRoute: AdminAdminInvoicesSyncLogRoute,AdminAdminLeadMagnetsIdRoute: AdminAdminLeadMagnetsIdRoute,AdminAdminMentoringsIdRoute: AdminAdminMentoringsIdRoute,AdminAdminQuestionnairesResponseIdRoute: AdminAdminQuestionnairesResponseIdRoute,AdminAdminQuestionnairesBilderRoute: AdminAdminQuestionnairesBilderRoute,AdminAdminTtpaIdRoute: AdminAdminTtpaIdRoute,AdminAdminTtpaVorlageRoute: AdminAdminTtpaVorlageRoute,AdminAdminWahlkalenderPruefeingangRoute: AdminAdminWahlkalenderPruefeingangRoute,AdminAdminBroadcastsIndexRoute: AdminAdminBroadcastsIndexRoute,AdminAdminClientsIndexRoute: AdminAdminClientsIndexRoute,AdminAdminCoursesIndexRoute: AdminAdminCoursesIndexRoute,AdminAdminDownloadsIndexRoute: AdminAdminDownloadsIndexRoute,AdminAdminEmailsIndexRoute: AdminAdminEmailsIndexRoute,AdminAdminInvoicesIndexRoute: AdminAdminInvoicesIndexRoute,AdminAdminLeadMagnetsIndexRoute: AdminAdminLeadMagnetsIndexRoute,AdminAdminMentoringsIndexRoute: AdminAdminMentoringsIndexRoute,AdminAdminQuestionnairesIndexRoute: AdminAdminQuestionnairesIndexRoute,AdminAdminTtpaIndexRoute: AdminAdminTtpaIndexRoute,AdminAdminKiTexteVorschauIdRoute: AdminAdminKiTexteVorschauIdRoute,AdminAdminWahlkalenderVorschauBundeslandRoute: AdminAdminWahlkalenderVorschauBundeslandRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const CockpitCockpitFragebogenRouteChildren = {
  CockpitCockpitFragebogenSlugRoute: CockpitCockpitFragebogenSlugRoute,CockpitCockpitFragebogenIndexRoute: CockpitCockpitFragebogenIndexRoute
}

const CockpitCockpitFragebogenRouteWithChildren = CockpitCockpitFragebogenRoute._addFileChildren(CockpitCockpitFragebogenRouteChildren)




const CockpitCockpitHundertTageVorlagenRouteChildren = {
  CockpitCockpitHundertTageVorlagenKaemmereiRoute: CockpitCockpitHundertTageVorlagenKaemmereiRoute,CockpitCockpitHundertTageVorlagenKrisenplanRoute: CockpitCockpitHundertTageVorlagenKrisenplanRoute,CockpitCockpitHundertTageVorlagenIndexRoute: CockpitCockpitHundertTageVorlagenIndexRoute
}

const CockpitCockpitHundertTageVorlagenRouteWithChildren = CockpitCockpitHundertTageVorlagenRoute._addFileChildren(CockpitCockpitHundertTageVorlagenRouteChildren)



const CockpitCockpitHundertTageRouteChildren = {
  CockpitCockpitHundertTagePhaseRoute: CockpitCockpitHundertTagePhaseRoute,CockpitCockpitHundertTageIdeenRoute: CockpitCockpitHundertTageIdeenRoute,CockpitCockpitHundertTageTtpaRoute: CockpitCockpitHundertTageTtpaRoute,CockpitCockpitHundertTageVorlagenRoute: CockpitCockpitHundertTageVorlagenRouteWithChildren,CockpitCockpitHundertTageIndexRoute: CockpitCockpitHundertTageIndexRoute,CockpitCockpitHundertTageAnfrageKeyRoute: CockpitCockpitHundertTageAnfrageKeyRoute,CockpitCockpitHundertTageKapitelSlugRoute: CockpitCockpitHundertTageKapitelSlugRoute,CockpitCockpitHundertTageKapitelIndexRoute: CockpitCockpitHundertTageKapitelIndexRoute
}

const CockpitCockpitHundertTageRouteWithChildren = CockpitCockpitHundertTageRoute._addFileChildren(CockpitCockpitHundertTageRouteChildren)




const CockpitCockpitKurseRouteChildren = {
  CockpitCockpitKurseSlugRoute: CockpitCockpitKurseSlugRoute,CockpitCockpitKurseIndexRoute: CockpitCockpitKurseIndexRoute
}

const CockpitCockpitKurseRouteWithChildren = CockpitCockpitKurseRoute._addFileChildren(CockpitCockpitKurseRouteChildren)



const CockpitRouteChildren = {
  CockpitCockpitDownloadsRoute: CockpitCockpitDownloadsRoute,CockpitCockpitFragebogenRoute: CockpitCockpitFragebogenRouteWithChildren,CockpitCockpitHilfeRoute: CockpitCockpitHilfeRoute,CockpitCockpitHundertTageRoute: CockpitCockpitHundertTageRouteWithChildren,CockpitCockpitKaeufeRoute: CockpitCockpitKaeufeRoute,CockpitCockpitKurseRoute: CockpitCockpitKurseRouteWithChildren,CockpitCockpitMeineAusstattungRoute: CockpitCockpitMeineAusstattungRoute,CockpitCockpitPasswoerterRoute: CockpitCockpitPasswoerterRoute,CockpitCockpitProfilRoute: CockpitCockpitProfilRoute,CockpitCockpitRechnungenRoute: CockpitCockpitRechnungenRoute,CockpitCockpitSocialMediaRoute: CockpitCockpitSocialMediaRoute,CockpitCockpitSupportRoute: CockpitCockpitSupportRoute,CockpitCockpitWahlkalenderRoute: CockpitCockpitWahlkalenderRoute,CockpitCockpitIndexRoute: CockpitCockpitIndexRoute,CockpitCockpitWahlkalenderAenderungMeldenRoute: CockpitCockpitWahlkalenderAenderungMeldenRoute,CockpitCockpitWahlkalenderBeobachtetRoute: CockpitCockpitWahlkalenderBeobachtetRoute
}

const CockpitRouteWithChildren = CockpitRoute._addFileChildren(CockpitRouteChildren)




const KontaktRouteChildren = {
  KontaktDankeRoute: KontaktDankeRoute,KontaktIndexRoute: KontaktIndexRoute
}

const KontaktRouteWithChildren = KontaktRoute._addFileChildren(KontaktRouteChildren)




const WissenKurseRouteChildren = {
  WissenKurseSlugRoute: WissenKurseSlugRoute,WissenKurseIndexRoute: WissenKurseIndexRoute
}

const WissenKurseRouteWithChildren = WissenKurseRoute._addFileChildren(WissenKurseRouteChildren)




const WissenMentoringsRouteChildren = {
  WissenMentoringsSlugRoute: WissenMentoringsSlugRoute,WissenMentoringsIndexRoute: WissenMentoringsIndexRoute
}

const WissenMentoringsRouteWithChildren = WissenMentoringsRoute._addFileChildren(WissenMentoringsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R100TageRoute: R100TageRouteWithChildren,R404Route: R404Route,AdminRoute: AdminRouteWithChildren,CockpitRoute: CockpitRouteWithChildren,BuergermeisterwahlProjekteRoute: BuergermeisterwahlProjekteRoute,DatenschutzRoute: DatenschutzRoute,ImpressumRoute: ImpressumRoute,InternRoute: InternRoute,KontaktRoute: KontaktRouteWithChildren,SeitenuebersichtRoute: SeitenuebersichtRoute,UeberUnsRoute: UeberUnsRoute,UnsubscribeRoute: UnsubscribeRoute,WahlkampfagenturRoute: WahlkampfagenturRoute,BlogSlugRoute: BlogSlugRoute,CasesSlugRoute: CasesSlugRoute,CockpitLoginRoute: CockpitLoginRoute,CockpitPasswortVergessenRoute: CockpitPasswortVergessenRoute,CockpitResetPasswordRoute: CockpitResetPasswordRoute,EventsAbsagenRoute: EventsAbsagenRoute,InternMfaRoute: InternMfaRoute,InternResetPasswordRoute: InternResetPasswordRoute,InternSetupRoute: InternSetupRoute,KaufenAbbruchRoute: KaufenAbbruchRoute,KaufenBestaetigungRoute: KaufenBestaetigungRoute,KostenlosBestaetigenRoute: KostenlosBestaetigenRoute,MentoringDankeRoute: MentoringDankeRoute,PolitischKommunizierenGemeindekommunikationRoute: PolitischKommunizierenGemeindekommunikationRoute,PolitischKommunizierenKrisenkommunikationRoute: PolitischKommunizierenKrisenkommunikationRoute,PolitischKommunizierenPolitischeKommunikationRoute: PolitischKommunizierenPolitischeKommunikationRoute,PolitischKommunizierenVerbandskommunikationRoute: PolitischKommunizierenVerbandskommunikationRoute,TerminDankeRoute: TerminDankeRoute,TerminDankeEmailRoute: TerminDankeEmailRoute,ThemenSlugRoute: ThemenSlugRoute,TtpaSlugRoute: TtpaSlugRoute,WahlenGewinnenBuergermeisterwahlRoute: WahlenGewinnenBuergermeisterwahlRoute,WahlenGewinnenDirektkandidatenRoute: WahlenGewinnenDirektkandidatenRoute,WahlenGewinnenParteikampagnenRoute: WahlenGewinnenParteikampagnenRoute,WahlenGewinnenPersonalratswahlRoute: WahlenGewinnenPersonalratswahlRoute,WahlenGewinnenWahlkampfRoute: WahlenGewinnenWahlkampfRoute,WahlkalenderBundeslandRoute: WahlkalenderBundeslandRoute,WissenDownloadsRoute: WissenDownloadsRoute,WissenKeynotesRoute: WissenKeynotesRoute,WissenKurseRoute: WissenKurseRouteWithChildren,WissenMentoringsRoute: WissenMentoringsRouteWithChildren,BlogIndexRoute: BlogIndexRoute,EventsIndexRoute: EventsIndexRoute,KostenlosSlugStepRoute: KostenlosSlugStepRoute,KaufenSlugIndexRoute: KaufenSlugIndexRoute,KostenlosSlugIndexRoute: KostenlosSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)